<template>
  <div>
    <h1>Reset password</h1>
    <p class="text-muted">Enter the e-mail address you use to sign in to.</p>

    <ValidationObserver
      v-slot="{ invalid, passes }"
      ref="emailFormObserver"
      tag="div">
      <el-form
        v-loading="loading"
        ref="emailForm"
        :model="form"
        label-position="top"
        @submit.native.prevent="passes(() => handleForm('emailFormObserver'))">

        <form-alerts :messages="invalidMsg"/>

        <el-alert
          v-if="successMsg != ''"
          :title="successMsg"
          type="success"
          class="mb-5"
          show-icon/>

        <ValidationProvider
          v-slot="{ errors }"
          :rules="rules.email"
          name="e-mail"
          vid="email"
          slim>
          <el-form-item
            :error="errors[0]"
            :required="checkRequired(rules.email)"
            label="E-mail">
            <el-input
              v-model="form.email"
              type="email"
              name="email"/>
          </el-form-item>
        </ValidationProvider>

        <el-form-item>
          <el-button
            native-type="submit"
            type="primary">Send link
          </el-button>
        </el-form-item>
      </el-form>
    </ValidationObserver>

    <hr>

    <router-link
      :to="{name: 'auth.login'}"
      class="el-button el-button--text">Login
    </router-link>
  </div>
</template>

<script>
  import forms from '@/shared/mixins/forms'
  import { postRequest } from '@/shared/utils/http'
  import { rules } from './validation'

  export default {

    mixins: [
      forms
    ],

    data: () => {
      return {
        rules,
        form: {
          email: ''
        },
        successMsg: ''
      }
    },

    methods: {
      submitForm: function () {
        return new Promise((resolve, reject) => {
          postRequest('/password/email', this.form)
            .then(response => {
              this.successMsg = response.msg

              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/auth/pages/auth/Email.vue